'use client'

import { MantineProvider } from '@mantine/core'
import { walmartTheme } from '@/tenants/walmart/theme/walmartTheme'
import { walmartCssResolver } from '@/tenants/walmart/theme/walmartCssResolver'
import './walmartGlobal.css'

// The root layout stamps data-tenant on <html>, so this selector outranks variables.css and the
// :root blocks that nested rebrand providers emit by specificity, whatever order they load in.
const WALMART_ROOT = ":root[data-tenant='walmart']"

export default function WalmartThemeProvider({ children }: { children: React.ReactNode }) {
    return (
        <MantineProvider theme={walmartTheme} cssVariablesResolver={walmartCssResolver} cssVariablesSelector={WALMART_ROOT}>
            {children}
        </MantineProvider>
    )
}
